import React from 'react';
import { ErrorSection } from '../error-section/error-section';
import isNil from '../../core/helpers/is-nil';

export const QueryErrorHandler: React.FC<{
  children: React.ReactNode;
  error?: Error | null | unknown;
  debugInfo?: string;
}> = ({ children, error, debugInfo }) => {
  if (isNil(error)) {
    return children;
  }
  return <ErrorSection debugInfo={debugInfo} error={error} />;
};
